import { useTranslation } from "@/i18n/useTranslation";

const SkipLink = () => {
  const { locale } = useTranslation();

  return (
    <a href="#main-content" className="skip-link">
      {locale === "fr" ? "Passer au contenu principal" : "Skip to main content"}
    </a>
  );
};

export default SkipLink;
